import { hooks } from '@/store.js';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import showErrMessage from '@/utils/showErrMessage.js';
import { Form } from '@heroui/react';
import { useRequest } from 'ahooks';
import { memo, useState } from 'react';
import isEqual from 'react-fast-compare';
import { toast } from 'sonner';
import AirPlaneAutocomplete from '../AirPlaneAutocomplete/index.jsx';
import SheetWrapper, { SheetWrapperHeader } from '../SheetWrapper/index.jsx';
import { planDetailEvent } from '@/pages/PlanDetail/utils/event.js';

interface IProps {
  // defaultValue?: AirplaneInit;
  onClose: () => void;
  date: string;
  // onSuccess: () => void;
  planId: string;
  orderIdx?: number;
}

const Inner = memo(
  ({
    // defaultValue,
    onClose,
    date,
    // onSuccess,
    planId,
    orderIdx,
  }: IProps) => {
    const client = hooks.useClient();

    const { runAsync, loading } = useRequest(
      async (payload: { [k: string]: FormDataEntryValue }) => {
        if (!date || !planId) throw new Error('参数不全');
        const { no } = payload;

        await client.events.put({
          date,
          type: 'airplane',
          airplane: {
            no: no as string,
          },
          planId,
          orderIdx,
        });
      },
      {
        manual: true,
        onError: showErrMessage,
        onSuccess() {
          toast.success('添加成功');
          setTimeout(() => {
            planDetailEvent.emit('requestRefresh');
          }, 200);
          onClose();
        },
      }
    );

    return (
      <Form
        className='w-full !block pb-safe '
        validationBehavior='native'
        onSubmit={(e) => {
          e.stopPropagation();
          e.preventDefault();
          const data = Object.fromEntries(new FormData(e.currentTarget));

          // STEP: 创建记录
          runAsync(data);
        }}
      >
        {/* <AddFormHeader onClose={onClose} loading={loading} /> */}

        <SheetWrapperHeader title='添加交通' align='left' />

        <div className='px-6 pt-10 pb-10'>
          <div className=' mb-6'>
            <article className='bg-black text-white w-max rounded-full text-base  py-1 pl-1 pr-6 flex items-center font-semibold'>
              <i className='ic-outline md-flight_takeoff text-center leading-[48px] w-12 h-12 rounded-full bg-white text-black block text-xl mr-3' />
              飞机
            </article>
          </div>
          <AirPlaneAutocomplete />
        </div>
      </Form>
    );
  },
  isEqual
);

const Modal = NiceModal.create((props: IProps) => {
  const [closeKey, setCloseKey] = useState(0);
  return (
    <SheetWrapper closeKey={closeKey}>
      <Inner {...props} onClose={() => setCloseKey(+new Date())} />
    </SheetWrapper>
  );
});

export const UseAddTransport = () => {
  const modal = useModal(Modal);
  return {
    show: modal.show,
  };
};
